import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import { createUseStyles, Markdown, Modal, useTheme } from '@Sage/hoi-poi-ui';

import styles from './styles/AddOnInfo';

const useStyles = createUseStyles(styles, 'AddOnInfo');

const AddOnInfo = memo(({ content, img, videoSrc, linkCallback, ...props }) => {
    const classes = useStyles();
    const theme = useTheme();

    const modalProps = useMemo(() => {
        return {
            size: 'large',
            autoHeight: false,
            ...props,
        };
    }, [props]);

    const renderContent = useMemo(() => {
        const contentProps = {
            className: classes.content,
            content,
            linkCallback,
            overrides: {
                a: { target: '_blank' },
                p: { color: theme.colors.textLight.secondary },
                ul: {
                    overrides: {
                        listItem: { style: { margin: 0 } },
                        Text: { color: theme.colors.textLight.secondary },
                    },
                },
            },
        };
        return <Markdown {...contentProps} />;
    }, [classes.content, content, linkCallback, theme]);

    const iframeProps = useMemo(
        () => ({
            src: videoSrc,
            allowFullScreen: true,
        }),
        [videoSrc],
    );

    const renderPic = useMemo(() => {
        switch (true) {
            case !!videoSrc:
                return <iframe title="vimeo-player" {...iframeProps} />;
            case !!img:
                return <img src={img.src} alt={img.alt || ''} />;
            default:
                return null;
        }
    }, [iframeProps, img, videoSrc]);

    return (
        <Modal {...modalProps}>
            <div className={classes.main}>
                {renderContent && <div className={classes.content}>{renderContent}</div>}
                {renderPic && <div className={classes.pic}>{renderPic}</div>}
            </div>
        </Modal>
    );
});

AddOnInfo.propTypes = {
    content: PropTypes.string,
    img: PropTypes.shape({
        src: PropTypes.string,
        alt: PropTypes.string,
    }),
    videoSrc: PropTypes.string,
    isOpen: PropTypes.bool,
    title: PropTypes.string,
    confirmText: PropTypes.string,
    cancelText: PropTypes.string,
    middleButtonText: PropTypes.string,
    onCancel: PropTypes.func,
    onConfirm: PropTypes.func,
    onMiddleButton: PropTypes.func,
    linkCallback: PropTypes.func,
};

export default AddOnInfo;
